import "./Services.module.css";
import AutoMotiGalvene from "@/reusable_sections/Header";
import SolucoesEmSustentabilidadeEGestao from "./sections/SolucoesEmSustentabilidadeEGestao";
import JoinGreystonesuppliesToday from "./sections/JoinGreystonesuppliesToday";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <AutoMotiGalvene />
      <SolucoesEmSustentabilidadeEGestao />
      <JoinGreystonesuppliesToday />
      <Footer />
    </div>;
}